import React, { useEffect, useState, useMemo, memo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Box, Button, IconButton, useTheme, Dialog, DialogActions, DialogContent, DialogTitle, DialogContentText, FormControl, Select, MenuItem } from '@mui/material';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import { tokens } from '../../../theme';
import Header from "../../../components/Header";
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import AddIcon from '@mui/icons-material/Add';
import { useNavigate } from 'react-router-dom';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import useMediaQuery from '@mui/material/useMediaQuery';
import { deleteDealer, editDealer, getDealers } from '../../../redux/slice/dealer.slice';
import { Image_URL } from '../../../utils/baseURL';

const Dealer = memo(({ data, columns }) => {
    if (!data || !Array.isArray(data)) {
        return <div>Loading...</div>;
    }
    return (
        <DataGrid
            rows={data}
            columns={columns}
            components={{ Toolbar: GridToolbar }}
            pageSize={5}
            rowsPerPageOptions={[5, 10]}
            getRowId={(row) => row._id}
            getRowClassName={(params) => {
                const liasoningItem = params.row.liasoningData?.[0];
                return liasoningItem && liasoningItem.status === "Enabled" ? 'disabled-row' : '';
            }}
            autoHeight
            density="compact"
            sx={{
                "@media print": {
                    "& .MuiDataGrid-toolbarContainer": {
                        display: "none !important"
                    },
                    "& .MuiDataGrid-root": {
                        color: "black !important",
                    },
                    "& .MuiDataGrid-cell": {
                        color: "black !important",
                    },
                    "& .MuiDataGrid-columnHeaders": {
                        color: "black !important",
                    },
                    "& .MuiDataGrid-footerContainer": {
                        color: "black !important",
                    },
                    "& .css-7ms3qr-MuiTablePagination-displayedRows": {
                        color: "black !important",
                    },
                },
            }}
        />
    );
});

const ListDealer = () => {
    const theme = useTheme();
    const dispatch = useDispatch();
    const colors = tokens(theme.palette.mode);
    const [open, setOpen] = useState(false);
    const [update, setUpdate] = useState(null);
    const [openView, setOpenView] = React.useState(false);
    const [viewData, setViewData] = useState(null);
    const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
    const [deleteConfirmOpen, setDeleteConfirmOpen] = useState(false);
    const [deletedealer, setDeleteDealer] = useState(null);
    const [imageViewOpen, setImageViewOpen] = useState(false);
    const [selectedImage, setSelectedImage] = useState(null);
    const [selectedStatus, setSelectedStatus] = useState("0");
    const imgUrl = Image_URL;
    const user = useSelector(state => state.users.users);
    const userId = localStorage.getItem('id');
    const DealerRegister = useSelector(state => state.dealer.Dealer) || [];
    const market = useSelector(state => state.comMarketing.Marketing);
    const productData = useSelector(state => state.products.products.products)
    const Liasoning = useSelector(state => state.liasoning.Liasoning);
    const isMobile = useMediaQuery('(max-width:500px)');


    const handleClickOpenView = () => {
        setOpenView(true);
    };
    const handleCloseView = () => {
        setOpenView(false);
    };

    const currentDate = new Date();
    const cutoffDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), 25);
    const groupDealersByCommissionPeriod = (dealers) => {
        const grouped = {};
        dealers.forEach(dealer => {
            const date = new Date(dealer.commisionCreatedAt);
            let year = date.getFullYear();
            let month = date.getMonth();
            if (date.getDate() <= 25) {
                month -= 1;
                if (month < 0) {
                    month = 11;
                    year -= 1;
                }
            }

            const periodKey = `${year}-${month}`;

            if (!grouped[periodKey]) {
                const startDate = new Date(year, month, 26);
                const endDate = new Date(year, month + 1, 25);
                grouped[periodKey] = {
                    startDate,
                    endDate,
                    formattedStartDate: startDate.toLocaleDateString('en-GB'),
                    formattedEndDate: endDate.toLocaleDateString('en-GB'),
                    dealers: []
                };
            }
            grouped[periodKey].dealers.push(dealer);
        });
        return grouped;
    };
    const filteredDealers = Array.isArray(DealerRegister) ? DealerRegister?.filter(dealer =>
        dealer.userId === userId && dealer.isDisabled &&
        new Date(dealer.commisionCreatedAt) <= currentDate
    ) : [];

    const groupedDealers = groupDealersByCommissionPeriod(filteredDealers);
    const sortedPeriods = Object.entries(groupedDealers).sort((a, b) =>
        new Date(b[1].endDate) - new Date(a[1].endDate)
    );
    const accountPayableFileNumbers = new Set();

    sortedPeriods.forEach(([periodKey, data]) => {
        data.dealers.forEach((dealer) => {
            const paymentDetails = dealer.dealerPaymentDetails || [];
            const matchingPayment = paymentDetails
                ?.flatMap((detail) => detail.DealerPaymentDetails || [])
                ?.find(
                    (payment) =>
                        payment.fileNo === dealer.data?.[0]?.fillNo &&
                        payment.DealerPaymentTotal > 0
                );

            const status = paymentDetails.flatMap((detail) => detail.status === "Complete")
            if (matchingPayment) {
                accountPayableFileNumbers.add(dealer.data?.[0]?.fillNo || 'N/A');
            }

        });
    });
    const uniqueAccountPayableFileNumbers = Array.from(accountPayableFileNumbers);

    useEffect(() => {
        const currentDate = new Date();
        if (currentDate.toLocaleDateString('en-GB') === cutoffDate.toLocaleDateString('en-GB')) {
        }
    }, [cutoffDate]);

    useEffect(() => {
        dispatch(getDealers());
    }, [dispatch]);
    const handleDelete = (id) => {
        setDeleteDealer(id);
        setDeleteConfirmOpen(true);
    };
    const confirmDelete = () => {
        if (deletedealer) {
            dispatch(deleteDealer(deletedealer));
            setDeleteConfirmOpen(false);
            setDeleteDealer(null);
        }
    }
    const cancelDelete = () => {
        setDeleteConfirmOpen(false);
        setDeleteDealer(null);
    }
    const getFQButtonText = (matchingLiasoning) => {
        const liasoningItem = matchingLiasoning.liasoningData.find(liason => liason.Dealer === matchingLiasoning._id);
        if (liasoningItem) {
            if (!liasoningItem.fileNo) {
                return "Application Pending";
            }

            if (liasoningItem.Query4) {
                return "Subcidy Received Status";
            }

            if (liasoningItem.Query3) {
                const claimDate = new Date(liasoningItem.CheckBox4date);
                const currentDate = new Date();
                const differenceInDays = Math.floor((currentDate - claimDate) / (1000 * 60 * 60 * 24));

                if (differenceInDays >= 25) {
                    return "Subcidy Received Status";
                } else {
                    return "Subcidy Claim Process";
                }
            }
            if (liasoningItem.Query2) {
                return "Net Meter Install";
            }
            if (liasoningItem.Query1) {
                return "Net Meter Document Qurier";
            }

            if (liasoningItem.SerialNumber) {
                return "Net Meter Document Upload";
            }

            if (liasoningItem.AmountL) {
                return "Site Details";
            }

            if (liasoningItem.FQPayment) {
                return "FQ Paid";
            }

            const submissionDate = new Date(liasoningItem.createdAt);
            const currentDate = new Date();
            const differenceInDays = Math.floor((currentDate - submissionDate) / (1000 * 60 * 60 * 24));

            if (differenceInDays < 10) {
                return "Application Submitted";
            } else {
                return "FQ Status";
            }
        }
        return "Application Pending";
    };


    const navigate = useNavigate();

    const handleEdit = (dataa) => {
        const matchingCommercialMarket = dataa?.data?.find(markets => markets.Dealer === dataa._id);
        const totalPaid = dataa?.PaymentDetails?.reduce((sum, payment) => sum + Number(payment.PaymentAmount || 0), 0) || 0;
        const marketAmount = matchingCommercialMarket?.TotalAmount || 0;

        setOpen(true);
        setUpdate(dataa);
        navigate('/admin/add-dealer', { state: { ...dataa, isDisabled: dataa.isDisabled } });
    };

    const handleView = (data) => {
        handleClickOpenView();
        setViewData(data)
    }

    const handleImageView = (imagePath) => {
        setSelectedImage(`${imgUrl}/${imagePath}`);
        setImageViewOpen(true);
    };

    const handleCloseImageView = () => {
        setImageViewOpen(false);
        setSelectedImage(null);
    };

    const confirmEdit = () => {
        dispatch(editDealer(update));
        dispatch(getDealers());
        setOpen(false);
    };

    const columns = useMemo(() => [
        {
            field: 'fillNo',
            headerName: 'File No',
            width: 100,
            renderCell: (params) => (
                params.row.data?.[0]?.fillNo || 'N/A'
            )
        },
        {
            field: 'ConsumerName', headerName: 'Name', width: 180,
            renderCell: (params) => (
                params.row.data?.[0]?.ConsumerName || params.row.ConsumerName || 'N/A'
            )
        },
        {
            field: 'PhoneNumber', headerName: 'Contact No', width: 150,
            renderCell: (params) => (
                params.row.data?.[0]?.PhoneNumber || params.row.PhoneNumber || 'N/A'
            )
        },
        {
            field: 'City_Village',
            headerName: 'City',
            width: 150,
            renderCell: (params) => (
                params.row.data?.[0]?.City_Village || params.row.City_Village || 'N/A'
            )
        },
        {
            field: 'SystemSize',
            headerName: 'System Size ',
            width: 120,
            renderCell: (params) => (
                params.row.data?.[0]?.SystemSizeKw || params.row.SystemSize || 'N/A'
            )
        },
        {
            field: 'payment_as_loan',
            headerName: 'Recd Payment As a loan ',
            width: 120,
            renderCell: (params) => (
                params.row.data?.[0]?.payment_as_loan || params.row.payment_as_loan || 'N/A'
            )
        },
        {
            field: 'type_loan',
            headerName: 'Type of loan ',
            width: 120,
            renderCell: (params) => (
                params.row.data?.[0]?.type_loan || params.row.type_loan || 'N/A'
            )
        },
        {
            field: 'SolarModule',
            headerName: 'Solar PV Module',
            width: 220,
            renderCell: (params) => {
                return params.row.MarketModuledata?.[0]?.productName || params.row.SolarModuleDetails?.[0]?.productName || 'N/A';
            }
        },
        {
            field: 'SolarInverter',
            headerName: 'Solar Grid Tie Inverter',
            width: 220,
            renderCell: (params) => {
                return params.row.marketInverterdata?.[0]?.productName || params.row.SolarInverterDetails?.[0]?.productName || 'N/A';
            }
        },
        {
            field: 'ConsumerNumber',
            headerName: 'Consumer Number',
            renderCell: (params) => (
                params.row.data?.[0]?.ConsumerNumber || params.row.ConsumerNumber || 'N/A'
            ),
            width: 150,
        },

        {
            field: 'amount', headerName: 'Amount', width: 120,
            renderCell: (params) => (
                params.row.data?.[0]?.TotalAmount || params.row.amount || 'N/A'
            )
        },
        {
            field: 'status',
            headerName: 'File Status',
            width: 250,
            filterable: true,
            valueGetter: (params) => {
                return params.row.liasoningData?.[0]?.applicationStatus || "N/A"
            },
            renderCell: (params) => {
                return params.row.liasoningData?.[0]?.applicationStatus || "N/A"
            }
        },
        {
            field: 'ee', headerName: 'Pending Payment', width: 150,
            renderCell: (params) => {

                const dealerId = params.row._id;
                const dealerData = params.row.AccountData;
                const totalAccountAmount = dealerData?.[0]?.AccountDetails?.reduce((sum, entry) => sum + Number(entry.AccountAmount || 0), 0) || 0;
                const totalAmount = params.row?.data?.[0]?.TotalAmount || 0;
                const pendingPayment = totalAmount - totalAccountAmount;

                return pendingPayment > 0 ? pendingPayment : 0;
            }
        },
        {
            field: 'gg', headerName: 'My Status', width: 200,
            renderCell: (params) => {
                const dealerData = DealerRegister && DealerRegister?.find(dealer => dealer._id === params.row._id);
                if (dealerData) {
                    const totalAmount = Number(dealerData.data?.[0]?.TotalAmount || 0);
                    const accountAmountSum = params.row.AccountData?.[0]?.AccountDetails?.reduce(
                        (sum, entry) => sum + Number(entry.AccountAmount || 0), 0
                    ) || 0;
                    const isInAccountPayableFileNumbers = uniqueAccountPayableFileNumbers.includes(dealerData.data?.[0]?.fillNo);
                    if (!dealerData.commisionCreatedAt && totalAmount > 0 && accountAmountSum > 0 && totalAmount === accountAmountSum) {
                        return "Invoice Pending";
                    } else if (dealerData.commisionCreatedAt && dealerData.requestStatus === "Pending") {
                        return "Payment Processing";
                    } else if (dealerData.requestStatus === "Approved" && !isInAccountPayableFileNumbers) {
                        return "Sent to Account Department";
                    } else if (isInAccountPayableFileNumbers) {
                        return "Payment Received";
                    }
                    return "All Pending";
                }
                return "N/A";
            }
        },
        {
            field: 'Action',
            headerName: 'Action',
            width: 130,
            renderCell: (params) => {
                const hasFillNo = params.row.data?.some(item => item.fillNo);
                const matchingDealer = Array.isArray(DealerRegister) ? DealerRegister?.find(dealer => dealer._id === params.row._id) : null;
                return (
                    <>
                        <IconButton aria-label="view" onClick={() => handleView(params.row)}>
                            <RemoveRedEyeIcon />
                        </IconButton>
                        <IconButton aria-label="edit" onClick={() => handleEdit(params.row)} disabled={!matchingDealer}>
                            <EditIcon />
                        </IconButton>
                        {/* <IconButton
                            aria-label="delete"
                            onClick={() => handleDelete(params.row._id)}
                            disabled={hasFillNo}
                        >
                            <DeleteIcon />
                        </IconButton> */}
                    </>
                );
            }
        }
    ], [market, Liasoning, DealerRegister]);

    const handleAddMarketing = () => {
        navigate('/admin/add-dealer');
    }

    const filteredData = useMemo(() => {
        const dealerData = Array.isArray(DealerRegister) ? DealerRegister : [];

        return dealerData.filter(item => {
            const totalAmount = Number(item.data?.[0]?.TotalAmount || 0);
            const accountAmountSum = item.AccountData?.[0]?.AccountDetails?.reduce(
                (sum, entry) => sum + Number(entry.AccountAmount || 0), 0
            ) || 0;
            const isInAccountPayableFileNumbers = uniqueAccountPayableFileNumbers.includes(item.data?.[0]?.fillNo);

            switch (selectedStatus) {
                case "All Pending":
                    return totalAmount === 0 || totalAmount !== accountAmountSum && !item.commisionCreatedAt && !isInAccountPayableFileNumbers;
                case "Payment Pending":
                    return !item.commisionCreatedAt && totalAmount > 0 && accountAmountSum > 0 && totalAmount === accountAmountSum;
                case "Payment Processing":
                    return item.commisionCreatedAt && item.requestStatus === "Pending";
                case "Sent to Account Dipartment":
                    return item.requestStatus === "Approved" && !isInAccountPayableFileNumbers;
                case "Payment Received":
                    return isInAccountPayableFileNumbers;
                default:
                    return true;
            }
        });
    }, [selectedStatus, DealerRegister, uniqueAccountPayableFileNumbers]);

    const filteredUserDealers = Array.isArray(DealerRegister) ? DealerRegister?.filter(dealer => dealer.userId === userId) : [];
    const allPendingCount = filteredUserDealers.filter(item => {
        const isInAccountPayableFileNumbers = uniqueAccountPayableFileNumbers.includes(item.data?.[0]?.fillNo);
        const totalAmount = Number(item.data?.[0]?.TotalAmount || 0);
        const accountAmountSum = item.AccountData?.[0]?.AccountDetails?.reduce(
            (sum, entry) => sum + Number(entry.AccountAmount || 0), 0
        ) || 0;
        return totalAmount === 0 || totalAmount !== accountAmountSum && !item.commisionCreatedAt && !isInAccountPayableFileNumbers;
    }).length;

    const pendingCount = (Array.isArray(DealerRegister) ? DealerRegister : []).filter(item => {
        const totalAmount = Number(item.data?.[0]?.TotalAmount || 0);
        const accountAmountSum = item.AccountData?.[0]?.AccountDetails?.reduce(
            (sum, entry) => sum + Number(entry.AccountAmount || 0), 0
        ) || 0;
        return !item.commisionCreatedAt && totalAmount > 0 && accountAmountSum > 0 && totalAmount === accountAmountSum;
    }).length;

    const processingCount = filteredUserDealers.filter(item =>
        item.commisionCreatedAt && item.requestStatus === "Pending"
    ).length;

    const approvedCount = filteredUserDealers.filter(item =>
        item.requestStatus === "Approved" && !uniqueAccountPayableFileNumbers.includes(item.data?.[0]?.fillNo)
    ).length;

    // const x = DealerRegister?.filter(dealer => dealer?.userId === userId)
    // console.log(x, filteredData);
    

    return (
        <Box m="2px">
            <Header
                title="CUSTOMER LIST"
                subtitle="Manage Your Customer List Here"
            />

            <Box display="flex" justifyContent="flex-end" mb={2}>

                <FormControl size="small" sx={{ display: { xs: 'block', md: 'inline-flex', paddingRight: "10px" } }}>
                    <Select
                        value={selectedStatus}
                        onChange={(event) => {
                            setSelectedStatus(event.target.value);
                        }}
                        sx={{
                            minWidth: '100%',
                            [theme.breakpoints.up('sm')]: {
                                minWidth: '150px',
                            },
                            [theme.breakpoints.down('sm')]: {
                                minWidth: '100%',
                            },
                            '& .MuiOutlinedInput-notchedOutline': {
                                borderColor: '#566585',
                            },
                            '&:hover .MuiOutlinedInput-notchedOutline': {
                                borderColor: '#566585',
                            },
                            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                borderColor: '#566585',
                                borderWidth: '2px',
                            },
                        }}
                    >
                        <MenuItem value="0">Status</MenuItem>
                        <MenuItem value="All Pending">
                            All Pending {allPendingCount > 0 ? `(${allPendingCount})` : '(0)'}
                        </MenuItem>
                        <MenuItem value="Payment Pending">
                            Invoice Pending {pendingCount > 0 ? `(${pendingCount})` : '(0)'}
                        </MenuItem>
                        <MenuItem value="Payment Processing">
                            Payment Processing {processingCount > 0 ? `(${processingCount})` : '(0)'}
                        </MenuItem>
                        <MenuItem value="Sent to Account Dipartment">Sent to Account Dipartment
                            {approvedCount > 0 ? `(${approvedCount})` : '(0)'}
                        </MenuItem>
                        <MenuItem value="Payment Received">
                            Payment Received {uniqueAccountPayableFileNumbers.length > 0 ? `(${uniqueAccountPayableFileNumbers.length})` : '(0)'}
                        </MenuItem>
                    </Select>
                </FormControl>


                <Button variant="contained" color="primary" startIcon={<AddIcon />} onClick={handleAddMarketing}>
                    Add Customer
                </Button>
            </Box>

            <Box
                height="75vh"
                sx={useMemo(() => ({
                    "& .MuiDataGrid-root": {
                        border: "none",
                    },
                    "& .MuiDataGrid-columnHeaders": {
                        backgroundColor: colors.blueAccent[700],
                        borderBottom: "none",
                    },
                    "& .MuiDataGrid-virtualScroller": {
                        backgroundColor: colors.primary[400],
                    },
                    "& .MuiDataGrid-footerContainer": {
                        borderTop: "none",
                        backgroundColor: colors.blueAccent[700],
                    },
                    "& .MuiCheckbox-root": {
                        color: `${colors.greenAccent[200]} !important`,
                    },
                    "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
                        color: `${colors.grey[100]} !important`,
                        fontSize: "13px !important",
                    },
                }), [colors])}
            >
                <Dealer data={Array.isArray(filteredData) ? filteredData.filter(dealer => dealer?.userId === userId) : []} columns={columns} />
            </Box>

            <Dialog
                open={imageViewOpen}
                onClose={handleCloseImageView}
                maxWidth="md"
                fullWidth
            >
                <DialogContent>
                    {selectedImage ? (
                        <div style={{ textAlign: 'center' }} >
                            {selectedImage.endsWith('.pdf') ? (
                                <iframe
                                    src={selectedImage}
                                    style={{ width: '800px', height: '80vh', border: 'none', textAlign: 'center' }}
                                    title="PDF"
                                />
                            ) : (
                                <img
                                    src={selectedImage}
                                    alt="Image"
                                    style={{ width: '600px', height: 'auto', textAlign: 'center' }}
                                />
                            )}
                        </div>
                    ) : (
                        <p>No image to display</p>
                    )}
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseImageView} sx={{ color: theme.palette.text.primary }}>
                        Close
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog
                fullScreen={fullScreen}
                open={openView}
                onClose={handleCloseView}
                aria-labelledby="responsive-dialog-title"
                maxWidth={"sm"}
                fullWidth
            >
                <DialogTitle id="responsive-dialog-title" style={{ backgroundColor: theme.palette.background.purple, textAlign: 'center' }}>
                    {"Dealer Details"}
                </DialogTitle>
                <DialogContent style={{ backgroundColor: theme.palette.background.purple }}>
                    <DialogContentText>
                        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '2px' }}>
                            <p style={{ backgroundColor: theme.palette.background.light, marginTop: 0, padding: '10px' }}><strong>File No : </strong> {viewData?.data?.[0]?.fillNo || 'N/A'}</p>
                            <p style={{ backgroundColor: theme.palette.background.light, marginTop: 0, padding: '10px' }}><strong>Name : </strong> {viewData?.data?.[0]?.ConsumerName || viewData?.ConsumerName || 'N/A'}</p>
                            <p style={{ backgroundColor: theme.palette.background.light, marginTop: 0, padding: '10px' }}><strong>Contact No : </strong> {viewData?.data?.[0]?.PhoneNumber || viewData?.PhoneNumber}</p>
                            <p style={{ backgroundColor: theme.palette.background.light, marginTop: 0, padding: '10px' }}><strong>City : </strong> {viewData?.data?.[0]?.City_Village || viewData?.City_Village || 'N/A'}</p>
                            <p style={{ backgroundColor: theme.palette.background.light, marginTop: 0, padding: '10px' }}><strong>System Size : </strong> {viewData?.data?.[0]?.SystemSizeKw || viewData?.SystemSize || 'N/A'}</p>
                            <p style={{ backgroundColor: theme.palette.background.light, marginTop: 0, padding: '10px' }}><strong>Recd Payment As a loan : </strong> {viewData?.data?.[0]?.payment_as_loan || viewData?.payment_as_loan || 'N/A'}</p>
                            <p style={{ backgroundColor: theme.palette.background.light, marginTop: 0, padding: '10px' }}><strong>Type of loan : </strong> {viewData?.data?.[0]?.type_loan || viewData?.type_loan || 'N/A'}</p>

                            <p style={{ backgroundColor: theme.palette.background.light, marginTop: 0, padding: '10px' }}><strong>Solar Pv Module : </strong> {viewData?.MarketModuledata?.[0]?.productName || viewData?.SolarModuleDetails?.[0]?.productName || 'N/A'}</p>
                            <p style={{ backgroundColor: theme.palette.background.light, marginTop: 0, padding: '10px' }}><strong>Solar Grid tie Inverter : </strong> {viewData?.marketInverterdata?.[0]?.productName || viewData?.SolarInverterDetails?.[0]?.productName || 'N/A'}</p>
                            <p style={{ backgroundColor: theme.palette.background.light, marginTop: 0, padding: '10px' }}><strong>Consumer Number : </strong> {viewData?.data?.[0]?.ConsumerNumber || 'N/A'}</p>
                            <p style={{ backgroundColor: theme.palette.background.light, marginTop: 0, padding: '10px' }}><strong>Amount : </strong> {viewData?.data?.[0]?.TotalAmount || viewData?.amount}</p>
                            <p style={{ backgroundColor: theme.palette.background.light, marginTop: 0, padding: '10px' }}><strong>File Status : </strong> {viewData?.liasoningData?.[0]?.applicationStatus || 'N/A'}</p>
                            <p style={{ backgroundColor: theme.palette.background.light, marginTop: 0, padding: '10px' }}><strong>Pending Payment :</strong> {viewData && viewData.data?.[0]?.TotalAmount ? (viewData.data[0].TotalAmount - (viewData.AccountData?.[0]?.AccountDetails?.reduce((sum, entry) => sum + Number(entry.AccountAmount || 0), 0) || 0)) : 0} </p>

                            {viewData?.MultipleDetails && viewData?.MultipleDetails.length > 0 && viewData?.MultipleDetails.map((detail, index) => (
                                <p style={{ backgroundColor: theme.palette.background.light, marginTop: 0, padding: '10px', display: 'flex', alignItems: 'center' }}>
                                    <strong>{detail?.inputField} : </strong>
                                    <div style={{ maxWidth: '100%', maxHeight: '80vh' }} >
                                        {detail?.dealerImage.endsWith('.pdf') ? (
                                            <iframe
                                                src={`${imgUrl}/${detail?.dealerImage}`}
                                                style={{ width: '50px', height: '50px', border: 'none', marginLeft: '20px' }}
                                                title="PDF Preview"
                                            />
                                        ) : (
                                            <img
                                                style={{ width: '50px', height: '50px', objectFit: 'cover', marginLeft: '20px' }}
                                                src={`${imgUrl}/${detail?.dealerImage}`}
                                                alt={detail?.inputField}
                                            />
                                        )}
                                    </div>
                                    <IconButton onClick={() => handleImageView(detail?.dealerImage)}>
                                        <RemoveRedEyeIcon />
                                    </IconButton>
                                </p>
                            ))}
                        </div>
                    </DialogContentText>
                </DialogContent>
                <DialogActions style={{ backgroundColor: theme.palette.background.purple }}>
                    <Button autoFocus onClick={handleCloseView} style={{ color: theme.palette.text.primary }}>
                        Close
                    </Button>
                </DialogActions>
            </Dialog>
            <Dialog open={deleteConfirmOpen} onClose={cancelDelete}>
                <DialogContent>
                    Are you sure you want to delete this Dealer Entry?
                </DialogContent>
                <DialogActions>
                    <Button onClick={cancelDelete} style={{ color: theme.palette.text.primary }}>No</Button>
                    <Button onClick={confirmDelete} style={{ color: theme.palette.text.primary }}>Yes</Button>
                </DialogActions>
            </Dialog>

        </Box >
    );
};

export default ListDealer;